<div class="d-inline-flex position-relative h-100">

  <div (click)="openDropdown()" class="d-inline-flex align-items-center">
    <ng-content></ng-content>
    <sb-icon class="dropdownIndicator" icon="chevronDown"></sb-icon>
  </div>

  <div class="dropdown-menu show" *ngIf="!selectedSubdropdown && dropdownOpen" style="{{placementStyle ? placementStyle : ''}}">
    <ul class="dropdown" [style.width.px]="dropdown.width ? dropdown.width : null">
      <ng-container *ngIf="dropdown.name || contentHeader">
        <li class="head d-block">
          <h3 class="m-0">{{dropdown.name ? (dropdown.name | translate) : dropdown.name}}</h3>
          <ng-content select="[dropdown-header]"></ng-content>
        </li>
        <li class="separator"></li>
      </ng-container>
      <ng-container *ngFor="let item of dropdown.items">
        <ng-container *ngPermissions="item.permissions ? item.permissions : null">
          <li *ngIf="item.separatorBefore" class="separator"></li>
          <li class="item" [class.active]="item.selected" (mouseenter)="item.hover = true" (mouseleave)="item.hover = false">
            <a *ngIf="item.subDropdown" class="item-link d-flex justify-content-between"
               (click)="selectSubdropdown($event, item.subDropdown)">
              <div>
                <sb-icon *ngIf="item.icon" [dualColor]="true" [icon]="item.icon+'Animation'"
                         [hover]="item.hover"></sb-icon>
                <span>{{item.name ? (item.name | translate) : item.name}}</span>
              </div>
              <sb-icon class="icon-in-btn" icon="chevronRight"></sb-icon>
            </a>
            <a *ngIf="!item.subDropdown && item.link" class="item-link d-flex justify-content-between" [sbRouterLink]="item.link"
               (click)="openDropdown()">
              <div>
                <sb-icon *ngIf="item.icon" [dualColor]="true" [icon]="item.icon+'Animation'"
                         [hover]="item.hover"></sb-icon>
                <span>{{item.name ? (item.name | translate) : item.name}}</span>
              </div>
              <sb-icon *ngIf="item.selected" class="icon-in-btn" icon="checked"></sb-icon>
            </a>
            <a *ngIf="!item.subDropdown && item.action" class="item-link d-flex justify-content-between" (click)="runAction(item)">
              <div>
                <sb-icon *ngIf="item.icon" [dualColor]="true" [icon]="item.icon+'Animation'"
                         [hover]="item.hover"></sb-icon>
                <span>{{item.name ? (item.name | translate) : item.name}}</span>
              </div>
              <sb-icon *ngIf="item.selected" icon="checked" class="icon-in-btn"></sb-icon>
            </a>
          </li>
          <li *ngIf="item.separatorAfter" class="separator"></li>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="contentFooter">
        <li class="separator"></li>
        <li class="item-content">
          <ng-content select="[dropdown-footer]"></ng-content>
        </li>
      </ng-container>
    </ul>
  </div>

  <div class="dropdown-menu show" *ngIf="selectedSubdropdown && dropdownOpen" style="{{placementStyle ? placementStyle : ''}}">
    <ul class="dropdown" [style.width.px]="dropdown.width ? dropdown.width : null">
      <li class="head d-flex justify-content-lg-start">
        <div (click)="selectSubdropdown($event, null)" class="d-flex align-items-center cursor-pointer">
          <span class="mr-2"><sb-icon icon="arrowLeftAlt" class="icon-in-btn"></sb-icon></span>
          <h3 class="m-0">{{selectedSubdropdown.name ? (selectedSubdropdown.name | translate) : selectedSubdropdown.name}}</h3>
        </div>
      </li>
      <li class="separator"></li>
      <li *ngFor="let item of selectedSubdropdown.items" class="item" [class.active]="item.selected">
        <a *ngIf="item.subDropdown" class="item-link d-flex justify-content-between" (click)="selectSubdropdown($event, item.subDropdown)">
          <div>
            <sb-icon *ngIf="item.icon" [icon]="item.icon" [hover]="item.hover"></sb-icon>
            <img *ngIf="item.image" [src]="item.image" alt="{{item.name}}" class="pic" width="20"/>
            <span class="ml-2">{{item.name ? (item.name | translate) : item.name}}</span>
          </div>
          <sb-icon icon="chevronRight" class="icon-in-btn"></sb-icon>
        </a>
        <a *ngIf="!item.subDropdown" class="item-link d-flex justify-content-between" (click)="runAction(item)">
          <div>
            <sb-icon *ngIf="item.icon" [dualColor]="true" [icon]="item.icon+'Animation'" [hover]="item.hover"></sb-icon>
            <img *ngIf="item.image" [src]="item.image" alt="{{item.name}}" class="pic" width="20"/>
            <span class="ml-2">{{item.name ? (item.name | translate) : item.name}}</span>
          </div>
          <sb-icon *ngIf="item.selected" class="icon-in-btn" icon="checked"></sb-icon>
        </a>
      </li>
    </ul>
  </div>
</div>
